import { secondsToTimeString } from '@/helpers/dateHelper';
import { strings } from '@/services/translation/strings';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { cellBase } from './calendarCellStyles';

interface AvailabilityCellProps {
  availableTimes: { start: number; end: number }[];
  hasMismatch: boolean;
}

export const MyCalendarAvailabilityCell: FC<AvailabilityCellProps> = ({ availableTimes, hasMismatch }) => (
  <div className="h-full w-full flex items-center text-gray-500 px-5">
    {availableTimes.map((shift, index) => (
      <div key={index} className={twMerge(cellBase, hasMismatch && 'border border-dotted border-gray-500 py-4')}>
        <p className="px-5">
          {strings.common.available.toUpperCase()}: {secondsToTimeString(shift.start)} -{' '}
          {secondsToTimeString(shift.end)}
        </p>
      </div>
    ))}
  </div>
);
